import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import intro from './common/intro';
import { getMultiLang, getGlobalStorage } from '@platform/api';
const welcome = require('./images/welcome.png');
const complete = require('./images/completeIcon.png');
const completeBg = require('./images/completeBg.png');

export default class Tourist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            desingerInstructDone: false,
            json: {}
        };
        this.isInsideTab = getGlobalStorage('localStorage', 'INSIDE_TAB');
    }
    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => { });
            }
        };
        getMultiLang({ moduleId: 'container_tourist', callback });
    }
    componentDidUpdate() {
        const { begin, show } = this.props;
        let { desingerInstructDone } = this.state
        if (show && !begin && desingerInstructDone === false) {
            this.startExplore()
        }
    }

    startExplore = () => {
        const { onChange, steps, selector, tag } = this.props;
        let { json } = this.state
        this.closeHelpModal();
        const config = steps;
        let isInsideTab = this.isInsideTab
        intro.start({
            isInsideTab,
            selector: selector,
            tag: tag,
            config,
            events: {
                onexit: (step) => {
                    if (step === config.length) {
                        this.setState({ desingerInstructDone: true })
                        onChange({ showHelpModal: true });
                    }
                }
            },
            json
        });
    }

    closeHelpModal = (animation = false) => {
        const { onChange } = this.props;
        this.setState({ desingerInstructDone: false })
        if (animation) {
            const delayTime = 700; // 毫秒
            let instructionsModal = document.querySelector('.tourist-modal');
            let instructionsButton = document.querySelector('[btn-code="TouristHelp"]');
            let bodyInf = document.body.getBoundingClientRect();
            if (instructionsButton) {
                const transfromElement = instructionsModal.firstChild;
                let targetInfo = transfromElement.getBoundingClientRect();
                transfromElement.style.transform = `translate(${bodyInf.width / 2 - targetInfo.width / 2}px, ${-(bodyInf.height / 2 - targetInfo.height / 2)}px) scale(0.1)`;
                transfromElement.style.transition = `all ease-out ${delayTime / 1000}s`;
                transfromElement.style.transformOrigin = 'top right';
                transfromElement.style.opacity = 0.3;
            }

            setTimeout(() => {
                onChange({ showHelpModal: false, showHelpTip: true });
                setTimeout(() => {
                    onChange({ showHelpTip: false });
                }, 2000);
            }, delayTime);
        } else {
            onChange({ showHelpModal: false });
        }
    }

    getEndDesc(desc,json) {
        if (desc) {
            return <span className='complete-desc'>{desc}</span>
        } else {
          return <span className='complete-desc'>{json['0005']}（<span className='complete-help'>{json['0010']}</span>）</span>
        }
    }
    render() {
        const { show, begin, end } = this.props;
        let { desingerInstructDone, json } = this.state
        return (
            show === true ?
                desingerInstructDone ?
                    (
                        <div className={`tourist-modal`}>
                            <div className='complete-body' style={{ width: 400, minHeight: 240 }}>
                                <img src={end.thumb || complete} className='complete'></img>
                                <div className='content' style={{
                                    background: `url(${end.bgThumb || completeBg})`, height: '100%',
                                    width: '100%',
                                    overflow: 'hidden',
                                    backgroundSize: 'cover'
                                }}>
                                    <div className='complete-title'>{end.title}</div>
                                    {this.getEndDesc(end.desc,json)}
                                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                                        <span className='complete-know' onClick={() => this.closeHelpModal()}>
                                            {json['0001']}{/* 我知道了 */}
                                        </span></div>
                                    <div className='see-guide-again' onClick={this.startExplore}>
                                        <span className='see-again-text'>{json['0002']}{/* 再看一遍 */}</span>
                                    </div>
                                    <i class="iconfont icon-guanbi guide-close" onClick={() => { this.closeHelpModal(!desingerInstructDone); }}></i>
                                </div>
                            </div>
                        </div >
                    ) :
                    (begin ?
                        <div className={`tourist-modal `} >
                            <div className='content tourist-modal-body' style={{ width: 763, height: 420 }}>
                                <div className='welcome'>
                                    <div className='welcome-title'>{begin.title}</div>
                                    <span className='welcome-desc'>{begin.desc}</span>
                                    <div class="explore" onClick={this.startExplore}>
                                        {json['0003']}{/* 开始探索 */}
                                    </div>
                                    <span onClick={() => this.closeHelpModal(true)} className='close-guide-modal'>
                                        {json['0004']}{/* 暂不了解 */}
                                    </span>
                                </div>
                                <img className='welcome-img' src={begin.thumb || welcome}></img>
                                <i class="iconfont icon-guanbi guide-close" onClick={() => { this.closeHelpModal(!desingerInstructDone); }}></i>
                            </div>
                        </div>
                        : <div />)
                : <div />
        );
    }
}
Tourist.propTypes = {
    begin: PropTypes.Object, // 开始页配置
    end: PropTypes.Object, //结束页配置
    steps: PropTypes.Array, //步骤配置
    tag: PropTypes.string,//新手指引的属性标识
    selector: PropTypes.string,//新手指引容器选择器
    events: PropTypes.Object,//事件处理
    show: PropTypes.bool,//是否显示
    onChange: PropTypes.func,//控制组件显示变化
};